<template> </template>

<script>
import { initEmploymentForm } from "@/assets/variables";

import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.js";
import pdfjsWorker from "pdfjs-dist/legacy/build/pdf.worker.entry";
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default {
    props: {
        value: { type: Object, default: initEmploymentForm },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        form: initEmploymentForm(),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            let needsInit = this.form.file != this.value.file;
            this.form = initEmploymentForm(this.value);
            if (needsInit) this.init();
        },

        emit() {
            this.$emit("input", this.form);
        },

        async init() {
            if (!(this.form.file instanceof File)) return;

            if (this.loading) return;
            else this.$emit("setLoading", true);

            try {
                let url = URL.createObjectURL(this.form.file);
                let pdf = await pdfjsLib.getDocument({ url }).promise;

                this.form.pages = await Promise.all(
                    new Array(pdf.numPages).fill("").map(async (_, i) => {
                        let page = await pdf.getPage(i + 1);

                        ////////////////////////////////////////////////////////
                        // Rendering
                        ////////////////////////////////////////////////////////
                        let scale = 300 / 72;
                        let viewport = page.getViewport({ scale });

                        let canvas = document.createElement("canvas");
                        canvas.width = Math.floor(viewport.width);
                        canvas.height = Math.floor(viewport.height);
                        let canvasContext = canvas.getContext("2d");

                        let renderContext = { canvasContext, viewport };
                        await page.render(renderContext).promise;

                        ////////////////////////////////////////////////////////
                        // Converting
                        ////////////////////////////////////////////////////////

                        let blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png", 1.0));

                        return new File([blob], `Page_${i + 1}.png`, { type: "image/png", lastModified: new Date().getTime() });
                    })
                );

                this.form.fields = [];
                this.emit();
                this.$store.commit("employment/form/page/increaseKey");
            } finally {
                this.$emit("setLoading", false);
            }
        },
    },
};
</script>

<style></style>
